import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="landing-tracker"
export default class extends Controller {
  static values = { variant: String }

  connect() {
    // Track page view on load
    this.trackEvent("page_view")
  }

  trackCtaClick(event) {
    this.trackEvent("cta_click")
    // Don't prevent default - let the link work normally
  }

  trackEvent(action) {
    if (!this.variantValue) return

    // Use fetch to track the event
    fetch("/landing/track_cta", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
      },
      body: JSON.stringify({
        variant: this.variantValue,
        action: action
      }),
      credentials: "same-origin"
    }).catch(error => {
      // Silently fail - don't break the page
      console.error("Failed to track event:", error)
    })
  }
}

